//import Libraries
import React, { Component } from 'react';
import { SMController, SMScene } from 'react-scrollmagic';
import {connect} from 'react-redux';

//import Components
import ScrollCard from './ScrollCard';
import Language from '../../../../language/language.json';

import * as homeActions from '../../actions/homeActions';

//import Style classes
import './ScrollCards.css'
import { join } from 'path';

class Scrollcards extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.onLoadMains();
    }
    
    render() {
        if(!this.props.mains){
            return (
                <div className="ScrollCards hidden">
                </div>
            );
        }

        let cards = this.props.mains.map( (obj, idx) => {
            return (
                    <ScrollCard 
                        key={'card'+idx}
                        universal={this.props.universal}
                        cardNumber={idx}
                        text={obj}/>
            )
        })

        return (
            <div className="ScrollCards hidden">
                {cards}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        mains : state.home.mains
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onLoadMains : () => {
            dispatch(homeActions.loadMains());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Scrollcards);


// WEBPACK FOOTER //
// ./src/pages/Home/ScrollSection/ScrollCards/ScrollCards.js